/**
 * URL-hash keys for the shipping feature's deep-linkable overlays, bound via
 * `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 */
export const SHIPPING_HASH = {
  /** `#edit/<id>` — ShippingFormDialog editing a shipment (listing). */
  edit: 'edit',
  /** `#delete/<id>` — single-shipment delete confirmation (listing). */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete',
  /** `#qr/<id>` — ShipmentQrDialog after box assignment (assign page). */
  qr: 'qr',
  /** `#scan` — camera QR scan dialog (assign page box selection). */
  scan: 'scan'
} as const;

export type ShippingHashKey =
  (typeof SHIPPING_HASH)[keyof typeof SHIPPING_HASH];
